import { render, staticRenderFns } from "./myTransfer.vue?vue&type=template&id=3adf26a0&scoped=true"
import script from "./myTransfer.vue?vue&type=script&lang=js"
export * from "./myTransfer.vue?vue&type=script&lang=js"
import style0 from "./myTransfer.vue?vue&type=style&index=0&id=3adf26a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf26a0",
  null
  
)

export default component.exports